import React, { useEffect, useState } from "react";
import { Card, CardBody, CardText } from "reactstrap";
import styles from "./style.module.scss";
import cx from "classnames";
import LoadingPlaceholder from "components/LoadingPlaceholder";
import { getUserPackages } from "api/PackagesApi";
import { getPOBoxByUser } from "api/POBoxApi";
import { errorHandler } from "utils/Api";
import { getUserData } from "utils/Session";
import { MOVEMENT_STATUS_CODES } from "utils/Constants";
import { Stepper, Step, StepLabel } from "@material-ui/core";
import Badge from '@mui/material/Badge';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import FlightLandIcon from '@mui/icons-material/FlightLand';
import AssignmentIcon from '@mui/icons-material/Assignment';
import StorefrontIcon from '@mui/icons-material/Storefront';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';


const UserPackageSummary = (props) => {
  const { className } = props;
  const [isLoading, setIsLoading] = useState();
  const [userPackages, setUserPackages] = useState([]);

  const steps = [
    {
      label: 'Camino',
      code: MOVEMENT_STATUS_CODES.ON_WAIT,
      icon: <LocalShippingIcon />,
    },
    {
      label: 'Miami',
      code: MOVEMENT_STATUS_CODES.ON_ORIGIN,
      icon: <WarehouseIcon />,
    },
    {
      label: 'Transito',
      code: MOVEMENT_STATUS_CODES.ON_TRANSIT,
      icon: <FlightTakeoffIcon />,
    },
    {
      label: 'CR',
      code: MOVEMENT_STATUS_CODES.ON_DESTINY,
      icon: <FlightLandIcon />,
    },
    {
      label: 'Aduanas',
      code: MOVEMENT_STATUS_CODES.ON_CUSTOMS,
      icon: <AssignmentIcon />,
    },
    {
      label: 'En Tienda',
      code: MOVEMENT_STATUS_CODES.ON_COURIER,
      icon: <StorefrontIcon />,
    },
    {
      label: 'En Ruta',
      code: MOVEMENT_STATUS_CODES.ON_ROUTE,
      icon: <DeliveryDiningIcon />,
    }
  ];

  useEffect(() => {
    setIsLoading(true);
    fetchUserPackages();
  }, [userPackages.length]);

  const fetchUserPackages = async () => {
    const userData = await getUserData();
    const poBox = await getPOBoxByUser(userData);
    const filter = {
      poBoxBoxesId: { eq: poBox.id }
    };
    getUserPackages(filter).then((r) => {
      if (r.length) {
        const defaultPackagesSum = Object.values(MOVEMENT_STATUS_CODES).reduce((a, v) => {
          a[v] = 0;
          return a;
        }, {});

        const boxes = r
          .filter(box => {
            return !box.isDeliveredbox;
          })
          .reduce((a, b) => {
            let boxStatus = b.cargoMovement?.status || MOVEMENT_STATUS_CODES.ON_WAIT;
            if (b.onRoute) {
              boxStatus = MOVEMENT_STATUS_CODES.ON_ROUTE;
            }
            a[boxStatus] += 1;
            return a;
          }, defaultPackagesSum);
        setUserPackages(boxes);
      } else {
        setUserPackages([]);
      }
    }).catch((e) => {
      errorHandler(e)
    }).finally((e) => {
      setIsLoading(false);
    });
  }

  const ColorlibStepIcon = (iconProps) => {
    const { icon } = iconProps;
    const step = steps[(icon - 1)];

    return (
      <div>
        <Badge badgeContent={userPackages[step.code]} color="primary">
          <div className={styles.stepIcon}>
            {step.icon}
          </div>
        </Badge>
      </div>
    );
  }


  return (
    <Card className={cx(["h-100", className])}>
      < CardBody className={styles.cardBody} >
        <CardText className={styles.cardText} >
          <div className={styles.cardTitle}>
            Cantidad de paquetes por estado
          </div>
          <div className={styles.cardTextContent}>
            <LoadingPlaceholder className={styles.status_graph} isLoading={isLoading}>
              <Stepper className={styles.stepper} alternativeLabel activeStep={1} >
                {steps.map((step) => (
                  <Step key={step.label}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>{step.label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </LoadingPlaceholder>
          </div>
        </CardText>

      </CardBody>
    </Card>
  );
}

export default UserPackageSummary;